export const tenMegaByteInByte = 10000000;
